(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/collections/board.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/collections/board.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.collections.Board = Backbone.Collection.extend({
    model: svs.maltipset.models.Row,
    currentRowIndex: 0,
    initialize: function(models, options) {
      this.coupon = options.coupon;
      this.initializeRows(options);
    },
    resetAndInitializeRows: function(options) {
      this.reset();
      this.initializeRows(options);
    },
    initializeRows: function(options) {
      if (options.xpertBaseRowMode) {
        options.system = svs.maltipset.constants.SYSTEM.M_SYSTEM;
      }

      var numberOfRows =
        options.system === svs.maltipset.constants.SYSTEM.NO_SYSTEM
          ? svs.maltipset.constants.NUMBER_OF_ROWS_NOSYSTEM
          : 1;

      for (var i = 0; i < numberOfRows; i++) {
        var addObject = {
          rowNo: i + 1,
          coupon: this.coupon,
          system: options.system,
          enabled: this.coupon.isEnabled(),
          xpertBaseRowMode: options.xpertBaseRowMode || false
        };

        if (
          !_.isUndefined(options.selectedMatchIndexes) &&
          options.selectedMatchIndexes.length > i
        ) {
          addObject.selectedMatchIndexes = options.selectedMatchIndexes[i];
        }
        this.add(addObject);
      }
    },
    getBoardData: function(getIncompleteRows) {
      var rows = [];
      this.each(function(row) {
        var rowArray = [];

        if (!getIncompleteRows && !row.get('completeRow')) {
          return;
        }

        _.each(row.get('selectedMatchIndexes'), function(selected, index) {
          if (selected === 1) {
            rowArray.push(index + 1);
          }
        });

        if (rowArray.length > 0 || getIncompleteRows) {
          rows.push(rowArray);
        }
      });

      return rows;
    },
    getUniqueMatchesSelected: function() {
      var matchesSelected = [];
      this.each(function(row) {
        _.each(row.get('selectedMatchIndexes'), function(item, index) {
          if (item === 1 && matchesSelected.indexOf(index) < 0) {
            matchesSelected.push(index);
          }
        });
      });

      return matchesSelected;
    },
    canConvertSystem: function(fromSystem, toSystem) {
      if (toSystem !== svs.maltipset.constants.SYSTEM.NO_SYSTEM) {
        if (fromSystem !== svs.maltipset.constants.SYSTEM.NO_SYSTEM) {
          return true;
        }
        return (
          this.getUniqueMatchesSelected().length <=
          svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_SYSTEM_MAX
        );
      }
      return (
        this.getUniqueMatchesSelected().length <=
        svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_NOSYSTEM
      );
    },
    convertSystem: function(fromSystem, toSystem) {
      this.currentRowIndex = 0;

      if (fromSystem === toSystem) {
        return true;
      }

      if (this.canConvertSystem(fromSystem, toSystem)) {
        var matchesNumbers = this.getUniqueMatchesSelected(),
          matchIndexes = [];

        for (var i = 0; i < svs.maltipset.constants.NUMBER_OF_MATCHES; i++) {
          matchIndexes.push(matchesNumbers.indexOf(i) >= 0 ? 1 : 0);
        }

        this.resetAndInitializeRows({
          selectedMatchIndexes: [matchIndexes],
          system: toSystem
        });
      } else {
        this.resetAndInitializeRows({ system: toSystem });
      }
    },
    setBoardToBaseRow: function() {
      this.resetAndInitializeRows({ xpertBaseRowMode: true });
      this.currentRowIndex = 0;
    },
    setBoardFromXpert: function(xpertWager) {
      var matchIndexes = this.convertBoardDataToSelectedMatchIndexes(
        _.pluck(xpertWager.get('numberBoards'), 'boardData')
      );

      this.resetAndInitializeRows({
        selectedMatchIndexes: matchIndexes,
        system: xpertWager.get('system')
      });
    },
    convertBoardDataToSelectedMatchIndexes: function(matchesNumbers) {
      var boards = [];

      _.each(matchesNumbers, function(row) {
        var matchIndexes = [];
        for (var i = 0; i < svs.maltipset.constants.NUMBER_OF_MATCHES; i++) {
          matchIndexes.push(row.indexOf(i + 1) >= 0 ? 1 : 0);
        }
        boards.push(matchIndexes);
      });

      return boards;
    },
    getSelectedMatchIndexes: function() {
      var rows = [];

      this.each(function(row) {
        rows.push(row.get('selectedMatchIndexes'));
      });

      return rows;
    },
    getTotalCompleteRows: function() {
      var totalCompleteRows = 0;

      if (
        this.coupon.get('system') === svs.maltipset.constants.SYSTEM.M_SYSTEM
      ) {
        totalCompleteRows = this.calculateMSystem(
          this.first().get('numberOfSelectedMatches')
        );
      } else if (
        this.coupon.get('system') === svs.maltipset.constants.SYSTEM.R_SYSTEM
      ) {
        totalCompleteRows = this.getRSystemRows(
          this.first().get('numberOfSelectedMatches')
        );
      } else {
        this.each(function(row) {
          totalCompleteRows += row.get('completeRow') ? 1 : 0;
        });
      }

      return totalCompleteRows;
    },
    getRSystemRows: function(noSelectedMatches) {
      switch (noSelectedMatches) {
        case 11:
          return 18;
        case 12:
          return 27;
        case 13:
          return 60;
        case 14:
          return 138;
        default:
          return 0;
      }
    },
    calculateMSystem: function(noSelectedMatches) {
      if (
        noSelectedMatches <
        svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_MSYSTEM_MIN
      ) {
        return 0;
      }

      var diff =
        noSelectedMatches -
        svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_NOSYSTEM;

      return (
        svs.utils.math.Factorial(noSelectedMatches) /
        (svs.maltipset.constants.FACT_OF_EIGHT * svs.utils.math.Factorial(diff))
      );
    },
    getTotalSelectedMatches: function() {
      var totalSelectedMatches = 0;

      this.each(function(row) {
        totalSelectedMatches += row.get('numberOfSelectedMatches');
      });

      return totalSelectedMatches;
    }
  });
})(Backbone, _, svs);


 })(window);